// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M20.1024 2.3077L19.41 1.58618L17.9669 2.97098L18.6593 3.6925C20.7294 5.84955 22 8.77539 22 12.0001C22 15.2248 20.7294 18.1506 18.6593 20.3077L17.9669 21.0292L19.41 22.414L20.1024 21.6925C22.5154 19.178 24 15.7614 24 12.0001C24 8.23883 22.5154 4.82222 20.1024 2.3077Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10 2.0001C15.5228 2.0001 20 6.47725 20 12.0001C20 17.5229 15.5228 22.0001 10 22.0001C4.47715 22.0001 0 17.5229 0 12.0001C0 6.47725 4.47715 2.0001 10 2.0001ZM13 16.4142L14.4142 15L11 11.5858V6.5H9V12.4142L13 16.4142Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-browse-gallery-filled')
export default class BrowseGalleryFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'browse-gallery-filled',
    }
  }
}
